import { SkillType, SkillDurationType, SkillTargetType } from "@/models/skills/SkillEnums";
import { ElementalType } from "@/models/common/ElementalType";
import { WeaponType, WeaponTypeName } from "@/models/items/ItemEnums";

export interface IElementInfo {
    name: string;
    cssClass: string;
    iconClass: string;
}

export function skillTypeName(t: SkillType): string {
    switch (t) {
        case SkillType.ACTIVE: return 'Active';
        case SkillType.PASSIVE: return 'Passive';
        case SkillType.AUTOMATIC_PASSIVE: return 'Auto passive';
        case SkillType.EX_PASSIVE: return 'Skill enhancement';
        case SkillType.AUTOMATIC_ACTIVATION: return 'Auto';
        default: return 'Unknown';
    }
}

export function durationTypeName(t: SkillDurationType): string {
    switch (t) {
        case SkillDurationType.INSTANT: return 'Regular';
        case SkillDurationType.BUFF: return 'Buff';
        case SkillDurationType.DEBUFF: return 'Debuff';
        case SkillDurationType.TIMED_TOGGLE: return 'Timed toggle';
        case SkillDurationType.ACTIVE_TOGGLE: return 'Active toggle';
        case SkillDurationType.AURA: return 'Aura';
        case SkillDurationType.ACTIVE_TOGGLE_PET: return 'Pet skill on/off';
        case SkillDurationType.SUMMON_DESUMMON_PET: return 'Toggle pet';
        case SkillDurationType.CHANGE_STANCE: return 'Stance change';
        case SkillDurationType.UNIFIED_SKILL: return 'Unified skill';
        default: return 'Unknown';
    }
}

export function targetTypeName(t: SkillTargetType): string {
    switch (t) {
        case SkillTargetType.SELF: return 'Caster';
        case SkillTargetType.ENEMY: return 'Enemy';
        case SkillTargetType.ALLIED: return 'Friendly actors';
        case SkillTargetType.PARTY_MEMBERS: return 'Party players';
        case SkillTargetType.ALL: return 'All';
        default: return 'Unknown';
    }
}

export function elementInfo(e: ElementalType): IElementInfo {
    switch (e) {
        case ElementalType.FIRE: return { name: 'Fire', cssClass: 'fire', iconClass: 'fa-fire' };
        case ElementalType.WATER: return { name: 'Water', cssClass: 'ice', iconClass: 'fa-snowflake-o' };
        case ElementalType.LIGHT: return { name: 'Light', cssClass: 'light', iconClass: 'fa-bolt' };
        case ElementalType.DARK: return { name: 'Dark', cssClass: 'dark', iconClass: 'fa-adjust' };
        default: return { name: 'No element', cssClass: 'nonelemental', iconClass: 'fa-genderless' };
    }
}

export function weaponNames(weapons: number[]): string {
    return weapons.map((v) => {
        const n = WeaponTypeName[v as WeaponType];
        return n ? n : `Weap ${v}`;
    }).join(', ');
}
